var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "shNoticeFormInfo",
      attrs: { model: _vm.callBidNotice, rules: _vm.callBidNoticeRules }
    },
    [
      _c("div", { staticClass: "simple-form" }, [
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label " }, [
            _c("label", { staticClass: "required" }, [_vm._v("公告名称")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "title" } },
                [
                  _c("el-input", {
                    staticClass: "width-1-5x",
                    attrs: {
                      disabled: _vm.add == null,
                      placeholder: "请输入内容"
                    },
                    model: {
                      value: _vm.callBidNotice.title,
                      callback: function($$v) {
                        _vm.$set(_vm.callBidNotice, "title", $$v)
                      },
                      expression: "callBidNotice.title"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label " }, [
            _c("label", { staticClass: "required" }, [_vm._v("上传附件")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _vm.add != null
              ? _c(
                  "span",
                  [
                    _c("swb-file-upload", {
                      attrs: {
                        fileGroup: "image-goods",
                        onBeforeUpload: _vm.onBeforeUpload,
                        onProgress: _vm.onProgress,
                        onDone: _vm.onUploadDone,
                        multipleFile: true
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.enrollfile.length > 0
              ? _c(
                  "div",
                  { staticClass: "file-area clearfix" },
                  _vm._l(_vm.enrollfile, function(file, index) {
                    return _c("swb-file-item", {
                      attrs: {
                        trackKey: index,
                        fileName: file.fileName,
                        fileUuid: file.fileUuid,
                        fileBrowseUrl: file.fileBrowseUrl,
                        fileDownloadUrl: file.fileDownloadUrl,
                        fileMd5: file.fileMd5,
                        deletable: true,
                        onDelete: _vm.deleteFile
                      }
                    })
                  })
                )
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _vm.add != null
          ? _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("模板名称")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "width-1-5x",
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.bizTplId,
                        callback: function($$v) {
                          _vm.bizTplId = $$v
                        },
                        expression: "bizTplId"
                      }
                    },
                    _vm._l(_vm.bizTplList, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id }
                      })
                    })
                  ),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "swb-btn swb-btn-link",
                    attrs: { type: "button", value: "生成模板" },
                    on: {
                      click: function($event) {
                        _vm.getBizNoticeContentModel()
                      }
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label " }, [
            _c("label", { staticClass: "required" }, [_vm._v("内容信息")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _c("swb-ck-editor", {
                ref: "theCkEditor",
                attrs: {
                  content: _vm.callBidNotice.content,
                  imageXtHandler: _vm.imageXtHandler
                }
              })
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7eedc0f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eedc0f6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/callbid/CallBidNoticeSave.vue
// module id = 3335
// module chunks = 0